import i18n from '../../i18n'

export default [
  {
    title: i18n.t('tour_base[0].title'),
    content: i18n.t('tour_base[0].content'),
    target: 'dashboard-menu',
    placement: 'right',
    yOffset: -25,
    xOffset: 25
  },
  {
    title: i18n.t('tour_base[1].title'),
    content: i18n.t('tour_base[1].content'),
    target: 'serie-menu',
    placement: 'right',
    yOffset: -25,
    xOffset: 25
  },
  {
    title: i18n.t('tour_base[2].title'),
    content: i18n.t('tour_base[2].content'),
    target: 'mercado-menu',
    placement: 'right',
    yOffset: -25,
    xOffset: 25
  },
  {
    title: i18n.t('tour_base[3].title'),
    content: i18n.t('tour_base[3].content'),
    target: 'customizado-menu',
    placement: 'right',
    yOffset: -25,
    xOffset: 25
  },
  {
    title: i18n.t('tour_base[4].title'),
    content: i18n.t('tour_base[4].content'),
    target: 'change-profile',
    placement: 'left',
    xOffset: 9
  },
  {
    title: i18n.t('tour_base[5].title'),
    content: i18n.t('tour_base[5].content'),
    target: 'edit-profile',
    placement: 'left',
    xOffset: 9
  },
  {
    title: i18n.t('tour_base[6].title'),
    content: i18n.t('tour_base[6].content'),
    target: 'help-button',
    placement: 'left',
    xOffset: 9
  },
  {
    title: i18n.t('tour_base[7].title'),
    content: i18n.t('tour_base[7].content'),
    target: 'logout',
    placement: 'left',
    xOffset: 9
  }
]
